/* Copyright (c) 2021 VMware, Inc. All rights reserved. VMware Confidential */

import { Injectable } from "@angular/core";
import { combineLatest, Observable, timer } from "rxjs";
import { filter, map } from "rxjs/operators";
import { AppVisibilityService } from "@app/services/visibility/visibility.service";

/**
 * Service used to create and manage timers. It takes into account if the App is
 * hidden. If so - the callbacks are postponed until the App is visible again.
 */
// @formatter:off
@Injectable({
    providedIn: "root"
})
// @formatter:on
export class TimerService {

    constructor(private visibilityService: AppVisibilityService) {
    }

    /**
     * Returns an Observable that emits every 'period' interval and starts after the 'initialDelay' period has passed.
     * Takes into account whether the app is visible and postpones emitting until it becomes visible.
     */
    public getTimerSource(period: number, initialDelay: number = period): Observable<number> {
        return combineLatest([this.visibilityService.visibleChanged,
                              timer(initialDelay, period)])
            .pipe(filter(combined => combined[0] /*latest visibleChanged*/),
                  map(combined => combined[1] /*latest timer tick*/));
    }
}
